<script setup lang="ts">
import dayjs from 'dayjs'
import card from './components/card.vue'

definePage({
  name: 'index',
  meta: {
    title: '首页',
  },
})

const router = useRouter()

const date = dayjs().format('YYYY-MM-DD')

const turnAroundList = ref([
  {
    name: '史赛克',
    en: 'SYK.US',
    type: 1,
  },
  {
    name: 'NOVA LTD',
    en: 'NVMI.US',
    type: 2,
  },
  {
    name: 'XL二南英伟',
    en: 'SYK.US',
    type: 1,
  },
])
const repurchaseList = ref([
  {
    name: '明源云',
    nember: '00909.HK',
    price: '270.20',
  },
  {
    name: '明源云',
    nember: '00909.HK',
    price: '270.20',
  },
  {
    name: '明源云',
    nember: '00909.HK',
    price: '270.20',
  },
])

const allocationAnalysisList = ref([
  {
    name: '广和通（300638.SZ）',
    doc: '支持卫星通信的无线通信模组产品',
    val: '+1.86% [ 业务支持 ]',
    type: 1,
  },
  {
    name: '国科微（300672.SZ）',
    doc: '业务暂不涉及商业航天领域',
    val: '+0.91% [ 中性澄清 ]',
    type: 2,
  },
])

const transactionList = ref([
  {
    name: '中投信息',
    val: '164.18亿(成交金额)',
    color: '#FDDA38',
  },
  {
    name: 'ABN',
    val: '94.50亿(成交金额)',
    color: '#C5CFDC',
  },
  {
    name: '创盈服务',
    val: '88.56亿(成交金额)',
    color: '#D8BEA2',
  },
])

function onSwitchPage(name: any) {
  router.push({ name })
}
</script>

<template>
  <FmPageLayout navbar tabbar :search="false" :back="false">
    <template #navbar>
      <div class="search">
        <van-search placeholder="经纪商异动" background="var(--background)" />
      </div>
    </template>
    <div class="card-list">
      <van-row :gutter="[10, 10]">
        <card title="经纪商异动">
          <div class="p-18px p-t-0px">
            <div class="text-7px color-[#999] font-500">
              {{ date }}
            </div>
            <div class="text-18px font-600">
              今日异动32家
            </div>
            <div class="flex items-center justify-between p-b-10px p-t-10px">
              <div>
                <div class="rounded-2px bg-[#E9F6F1] p-l-7px p-r-7px text-align-center text-15px color-[#22A875] line-height-25px">
                  增持
                </div>
                <div class="text-align-center text-15px color-[#22A875] line-height-25px">
                  18家
                </div>
              </div>
              <div class="h-50px w-1px bg-[#F1F1F1]" />
              <div>
                <div class="rounded-2px bg-[#FDEDED] p-l-7px p-r-7px text-align-center text-15px color-[#E51A2D] line-height-25px">
                  减持
                </div>
                <div class="text-align-center text-15px color-[#E51A2D] line-height-25px">
                  15家
                </div>
              </div>
            </div>
            <div class="text-15px fw-600">
              民银证券
            </div>
            <div class="text-11px">
              新吉奥房车(00805.HK)
            </div>
            <div class="m-b-10px text-11px color-[#22A875]">
              增持9.00%(210.20万股）
            </div>
            <van-button round type="primary" block size="small" @click="onSwitchPage('fluctuation')">
              查看更多
            </van-button>
          </div>
        </card>
        <card title="转多转空">
          <div class="p-18px p-t-0px">
            <div class="text-7px color-[#999] font-500">
              {{ date }}
            </div>
            <div v-for="(item) in turnAroundList" :key="item.name" class="flex items-center justify-between p-b-5px p-t-5px">
              <div>
                <div class="text-15px">
                  {{ item.name }}
                </div>
                <div class="text-11px">
                  {{ item.en }}
                </div>
              </div>
              <div v-if="item.type === 1" class="rounded-2px bg-[#E9F6F1] p-l-7px p-r-7px text-align-center text-15px color-[#22A875] line-height-25px">
                转空
              </div>
              <div v-else class="rounded-2px bg-[#FDEDED] p-l-7px p-r-7px text-align-center text-15px color-[#E51A2D] line-height-25px">
                转多
              </div>
            </div>
            <div class="m-b-5px text-7px color-[#999] font-500">
              显示前三条转多转空记录。
            </div>
            <van-button round type="primary" block size="small" @click="onSwitchPage('convert')">
              查看更多
            </van-button>
          </div>
        </card>
        <card title="一图财报" span="24">
          <div class="p-7px p-t-0px" @click="onSwitchPage('financial-report')">
            <img src="@/assets/images/banner.png" alt="">
          </div>
        </card>
        <card title="股份回购 (港股)" span="24">
          <div class="flex items-center justify-between gap-20px p-19px p-b-5px p-t-5px">
            <div>
              <div class="text-22px font-600 line-height-24px">
                600家<br>机构回家
              </div>
              <div class="m-t-10px text-15px color-[#666]">
                市场回购11.2%
              </div>
            </div>
            <div class="h-95px w-1px bg-[#F1F1F1]" />
            <div class="flex-1">
              <div v-for="(item, index) in repurchaseList" :key="index" class="flex items-center justify-between p-b-10px">
                <div>
                  <div class="text-13px font-600">
                    {{ item.name }}
                  </div>
                  <div class="text-9px color-[#666]">
                    {{ item.nember }}
                  </div>
                </div>
                <div class="text-9px color-[#666]">
                  {{ date }}
                </div>
                <div class="text-11px">
                  {{ item.price }}万
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-between p-15px p-t-5px">
            <div class="text-11px color-[#999]">
              截止{{ date }}
            </div>
            <div class="flex items-center color-[var(--background)]" @click="onSwitchPage('share-repurchase')">
              查看更多数据
              <FmIcon name="iconamoon:arrow-right-2-bold" class="text-16px" />
            </div>
          </div>
        </card>
        <card title="配售解析">
          <div class="p-18px p-t-0px">
            <div class="text-7px color-[#999] font-500">
              {{ date }}
            </div>
            <div class="m-t-10px text-15px font-600">
              今日概览
            </div>
            <div class="m-b-10px m-t-0px text-7px color-[#999]">
              今日 6 家公司披露配售 / 定增相关信
            </div>
            <div v-for="(item, index) in allocationAnalysisList" :key="index" class="m-b-5px">
              <div class="text-13px font-600">
                {{ item.name }}
              </div>
              <div class="text-7px color-[#666]">
                {{ item.doc }}
              </div>
              <div v-if="item.type === 1" class="text-7px color-[#22A875]">
                {{ item.val }}
              </div>
              <div v-else class="text-7px color-[#E51A2D]">
                {{ item.val }}
              </div>
            </div>
            <div class="m-t-10px text-7px color-[#666]">
              显示前二条配售解析记录。
            </div>
            <div class="m-t-10px flex items-center justify-center color-[var(--background)]" @click="onSwitchPage('parsing')">
              查看全部配售解析
              <FmIcon name="iconamoon:arrow-right-2-bold" class="text-16px" />
            </div>
          </div>
        </card>
        <card title="券商成交榜">
          <div class="p-18px p-t-0px">
            <div class="text-7px color-[#999] font-500">
              {{ date }}
            </div>
            <div v-for="(item, index) in transactionList" :key="index" class="m-b-13px m-t-11px flex items-center justify-between">
              <div class="h19px w35px text-center text-11px color-[#fff] line-height-19px" style="border-radius: 4px 0;" :style="{ background: item.color }">
                TOP{{ index + 1 }}
              </div>
              <div>
                <div class="text-15px">
                  {{ item.name }}
                </div>
                <div class="text-7px color-[#666]">
                  {{ item.val }}
                </div>
              </div>
            </div>
            <div class="m-t-10px text-7px color-[#666]">
              显示前三条券商成交记录。
            </div>
            <div class="m-t-10px flex items-center justify-center color-[var(--background)]" @click="onSwitchPage('transaction-list')">
              查看更多数据
              <FmIcon name="iconamoon:arrow-right-2-bold" class="text-16px" />
            </div>
          </div>
        </card>
      </van-row>
    </div>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.search {
  padding-right: 30px;

  :deep(.van-search__content) {
    border-radius: 10px;
  }
}

.card-list {
  padding: 10px;
  color: #333;
}
</style>
